export type StayReservationPackRow = {
  stay_reservation_id: string;
  stay_pack_id: string;
};

export function buildStayReservationPackRows(
  reservationId: string,
  packIds: string[],
): StayReservationPackRow[] {
  return [...new Set(packIds)].map((stayPackId) => ({
    stay_reservation_id: reservationId,
    stay_pack_id: stayPackId,
  }));
}

export function resolveReservationPackIds(
  relationRows: Array<{ stay_pack_id: string }>,
  legacyPackId: string | null,
): string[] {
  const relationIds = relationRows.map((row) => row.stay_pack_id).filter(Boolean);
  return [...new Set(relationIds.length > 0 ? relationIds : legacyPackId ? [legacyPackId] : [])];
}
